module.exports = __webpack_public_path__ + "static/media/pr.48f49ef6.svg";